import React from 'react';

const Vue = () => {
  return (
    <div>
      <h1>Vue Component</h1>
      <p>This is the Vue tutorial page.</p>
    </div>
  );
}

export default Vue;
